var app = angular.module("leonardo");

var SelectSectorDialog = function($scope, SectorRestService, FormErrorsService) {
  $scope.sector = null;

  $scope.sectorRestService = SectorRestService;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.confirm($scope.sector);
  };
};

app.controller('SelectSectorDialog', ['$scope', 'SectorRestService', 'FormErrorsService', SelectSectorDialog]);
